import * as React from 'react';
import { SummaryMobile } from './SummaryMobile';
import { useIsMobileDevice } from '../../hooks';

export const SummaryMobileContainer = () => {
  const isMobile = useIsMobileDevice();

  if (!isMobile) {
    return null;
  }

  return <SummaryMobile />;
};
